// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BellRingingBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M4.462 9.5a1.5 1.5 0 0 1-1.33-2.19A14.406 14.406 0 0 1 8.2 1.732 1.5 1.5 0 1 1 9.8 4.27a11.263 11.263 0 0 0-4 4.422 1.5 1.5 0 0 1-1.338.809Zm24.405-2.19A14.407 14.407 0 0 0 23.8 1.732a1.5 1.5 0 1 0-1.6 2.537 11.262 11.262 0 0 1 4 4.422 1.5 1.5 0 0 0 2.026.64 1.5 1.5 0 0 0 .642-2.021Zm-1.382 13.675A2.5 2.5 0 0 1 25.5 25h-4.093a5.5 5.5 0 0 1-10.815 0H6.5a2.5 2.5 0 0 1-1.989-4.015c.896-1.166 1.966-3.328 1.985-6.992A9.502 9.502 0 1 1 25.5 14c.019 3.657 1.089 5.819 1.985 6.985ZM18.29 25h-4.58a2.5 2.5 0 0 0 4.58 0Zm6.25-3c-1.02-1.625-2.024-4.196-2.043-7.992A6.5 6.5 0 1 0 9.5 14c-.019 3.802-1.023 6.375-2.043 8H24.54Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
